import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DataQueryCluster } from '../../models/data-query-cluster.model';
import { DataQueryField } from '../../models/data-query-field.model';

@Component({
    selector: 'app-drop-field-warning-dialog',
    templateUrl: './drop-field-warning-dialog.component.html',
    styleUrls: ['./drop-field-warning-dialog.component.css']
})
export class DropFieldWarningDialogComponent implements OnInit {

    // Injected Properties
    field: DataQueryField;
    removedFields: DataQueryField[];

    // Constructor
    constructor(
        private dialogRef: MatDialogRef<DropFieldWarningDialogComponent>,
        @Inject(MAT_DIALOG_DATA) private data: any
    ) { }

    // Event Functions
    ngOnInit(): void {
        this.field = this.data.field;
        this.removedFields = this.data.removedFields;
    }

    // UI Functions
    continue() {
        // PRE: the continue button is clicked
        // POST: closes the dialog with true, initiating dropping
        this.dialogRef.close(true);
    }

    cancel() {
        // PRE: the cancel button is clicked
        // POST: closes the dialog with false, doing nothing
        this.dialogRef.close(false);
    }
}
